export default __webpack_public_path__ + "static/media/dia7.bac94940.png";